import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";

export const isEntityClientOnboardingCase = (caseType?: string | null): boolean =>
  caseType === ComplianceCaseTypeEnum.EntityOnboarding ||
  caseType === ComplianceCaseTypeEnum.ClientOnboarding;
